var map = {
	"./locales": 33,
	"./locales.js": 33,
	"./ru": 41,
	"./ru/": 41,
	"./ru/calculate": 45,
	"./ru/calculate.js": 45,
	"./ru/contacts": 49,
	"./ru/contacts.js": 49,
	"./ru/equipment": 47,
	"./ru/equipment.js": 47,
	"./ru/footer": 44,
	"./ru/footer.js": 44,
	"./ru/header": 43,
	"./ru/header.js": 43,
	"./ru/home": 46,
	"./ru/home.js": 46,
	"./ru/index": 41,
	"./ru/index.js": 41,
	"./ru/info": 48,
	"./ru/info.js": 48,
	"./ua": 42,
	"./ua/": 42,
	"./ua/calculate": 52,
	"./ua/calculate.js": 52,
	"./ua/contacts": 56,
	"./ua/contacts.js": 56,
	"./ua/equipment": 54,
	"./ua/equipment.js": 54,
	"./ua/footer": 51,
	"./ua/footer.js": 51,
	"./ua/header": 50,
	"./ua/header.js": 50,
	"./ua/home": 53,
	"./ua/home.js": 53,
	"./ua/index": 42,
	"./ua/index.js": 42,
	"./ua/info": 55,
	"./ua/info.js": 55
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;